import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173d4080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spacingInput-container" }
const _hoisted_2 = { id: "outer-container" }
const _hoisted_3 = {
  class: "spacingInput spacing-top",
  placeholder: "0mm",
  contenteditable: "true",
  spellcheck: "false",
  oninput: "if(this.innerHTML.trim()==='<br>')this.innerHTML=''"
}
const _hoisted_4 = {
  class: "spacingInput spacing-left",
  placeholder: "0mm",
  contenteditable: "true",
  spellcheck: "false",
  oninput: "if(this.innerHTML.trim()==='<br>')this.innerHTML=''"
}
const _hoisted_5 = {
  class: "spacingInput spacing-bottom",
  placeholder: "0mm",
  contenteditable: "true",
  spellcheck: "false",
  oninput: "if(this.innerHTML.trim()==='<br>')this.innerHTML=''"
}
const _hoisted_6 = {
  class: "spacingInput spacing-right",
  placeholder: "0mm",
  contenteditable: "true",
  spellcheck: "false",
  oninput: "if(this.innerHTML.trim()==='<br>')this.innerHTML=''"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"spacing-box\" data-v-173d4080><div class=\"spacing-box-inside\" data-v-173d4080><div id=\"inner-container\" data-v-173d4080><div class=\"spacing-box\" data-v-173d4080><div class=\"spacing-box-inside\" data-v-173d4080><br data-v-173d4080></div></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dimension), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.dimension), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dimension), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.dimension), 1),
      _hoisted_7
    ])
  ]))
}